import { Select } from 'antd';
// import { DownSquareOutlined} from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import Roles from '../../library/dynamics/roles' ;
import styles from './CountrySelect.module.scss';
const { Option } = Select

function RoleSelect({ placeholder, value = null, onChange, ...otherProps }) {
    return (
        <Select 
          
            placeholder={placeholder}
            optionFilterProp="name"
            optionLabelProp="label"
            autoComplete="none"
            onChange={(val) => onChange(val, Roles.find(({ id }) => id === val))}
            value={value ?? undefined}
            showSearch
            {...otherProps}
        >
            {Roles.map((role) => {
                return (
                    <Option key={role.id} name={role.name} value={role.id} label={role.name}>
                        <div className={styles.option}>
                            {role.name}
                        </div>
                    </Option>
                )
            })}
        </Select>
    );
}

RoleSelect.propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func
}

export default RoleSelect;